//NOTE: LKG: We may want to find a different way to handle this, but this will work for now
import { applicationHistory } from './application-history';

export const connectToHistory = () => {
	applicationHistory.listen(location => {
		document.title = location.pathname;
	});
};



// WEBPACK FOOTER //
// ./src/common/title-handler.js